(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tinyrig-watch-before-buy"] && !Shopify.designMode) return;
  try {
    
  class TinyrigVideosSection {
  /** @param {HTMLElement} root */
    constructor(root) {
      this.root = root;
      this.featuredPanel = root.querySelector('[data-tinyrig-video-featured]');
      this.listItems = [...root.querySelectorAll('[data-tinyrig-video-list-item]')];
      this.bind();
    }

    bind() {
      this.listItems.forEach((item) => {
        item.addEventListener('click', () => this.selectVideo(item));
      });

      this.root.querySelectorAll('[data-tinyrig-video-play]').forEach((button) => {
        button.addEventListener('click', () => this.playFeatured(button));
      });
    }

    /** @param {HTMLElement} item */
    selectVideo(item) {
      if (!this.featuredPanel) return;

      const blockId = item.dataset.blockId;
      if (!blockId) return;

      this.listItems.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.blockId === blockId);
      });

      this.featuredPanel.dataset.blockId = blockId;
      this.featuredPanel.dataset.videoId = item.dataset.videoId || '';
      this.featuredPanel.dataset.videoTitle = item.dataset.videoTitle || '';
      this.featuredPanel.dataset.videoMeta = item.dataset.videoMeta || '';

      const posterImg = this.featuredPanel.querySelector('.tinyrig-videos__poster-img');
      if (posterImg && item.dataset.videoThumb) {
        posterImg.src = item.dataset.videoThumb;
        posterImg.alt = item.dataset.videoTitle || '';
      }

      const title = this.featuredPanel.querySelector('.tinyrig-videos__featured-title');
      if (title) title.textContent = item.dataset.videoTitle || '';

      const meta = this.featuredPanel.querySelector('.tinyrig-videos__featured-meta');
      if (meta) meta.textContent = item.dataset.videoMeta || '';

      this.resetPlayer(this.featuredPanel);
    }

    /** @param {HTMLElement} panel */
    resetPlayer(panel) {
      const poster = panel.querySelector('[data-tinyrig-video-play]');
      const iframeWrap = panel.querySelector('[data-tinyrig-video-iframe]');
      const iframe = panel.querySelector('.tinyrig-videos__iframe');
      if (poster) poster.hidden = false;
      if (iframeWrap) iframeWrap.hidden = true;
      if (iframe) iframe.src = '';
    }

    /** @param {HTMLElement} button */
    playFeatured(button) {
      const panel = button.closest('[data-tinyrig-video-featured]');
      if (!panel) return;

      const videoId = panel.dataset.videoId;
      if (!videoId) return;

      const poster = panel.querySelector('[data-tinyrig-video-play]');
      const iframeWrap = panel.querySelector('[data-tinyrig-video-iframe]');
      const iframe = panel.querySelector('.tinyrig-videos__iframe');
      if (!poster || !iframeWrap || !iframe) return;

      poster.hidden = true;
      iframeWrap.hidden = false;
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }
  }

  function initTinyrigVideos() {
    document.querySelectorAll('[data-tinyrig-videos-root]').forEach((root) => {
      if (root.dataset.tinyrigVideosInit) return;
      root.dataset.tinyrigVideosInit = 'true';
      new TinyrigVideosSection(root);
    });
  }

  initTinyrigVideos();
  document.addEventListener('shopify:section:load', initTinyrigVideos);

  } catch(e) { console.error(e); }
})();
})();
